/**
 * PRP Programs plan (program-only clinic): the practice app shows the PRP
 * workspace plus shared tools (schedule, clients, tasks, messages, groups,
 * settings). Full-EHR screens are hidden from menus and redirected here.
 * The server refuses e-prescribing and lab writes for these plans as well.
 */

export const PRP_ONLY_HOME = "/prp";

/**
 * Roles a PRP Programs clinic can assign. Provider stays for a program's own
 * psychiatrist (co-signs Presenting Problems); medical roles are left out.
 */
export const PRP_ONLY_ROLES = new Set(["org_admin", "prp_director", "prp_rc", "provider"]);

/** Default role for a new non-provider user on a PRP Programs plan. */
export const PRP_ONLY_DEFAULT_ROLE = "prp_rc";

/** Route prefixes a PRP Programs plan does not include. */
const BLOCKED_PREFIXES = [
  "/dashboard",
  "/tracker",
  "/prescriptions",
  "/camos",
  "/decision-support",
  "/encounters",
  "/reports",
  "/record-exchange",
  "/settings/record-exchange",
  "/settings/services-fees",
  "/settings/departments",
  "/settings/public-site",
  "/website-studio",
];

/** Settings pages hidden from the Settings menu on a PRP Programs plan. */
export const PRP_ONLY_HIDDEN_SETTINGS = new Set([
  "/settings/services-fees",
  "/settings/departments",
  "/settings/public-site",
  "/settings/public-site/studio",
  "/settings/integrations",
  "/settings/record-exchange",
]);

function under(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(prefix + "/");
}

/**
 * Where a PRP-only clinic is sent instead of `pathname`, or null when the
 * page is part of the plan. `/billing` itself (the subscription page) stays;
 * the claims workspace under `/billing/...` does not.
 */
export function prpOnlyRedirect(pathname: string): string | null {
  if (pathname === "/patients") return "/prp/caseload";
  if (pathname.startsWith("/billing/")) return PRP_ONLY_HOME;
  return BLOCKED_PREFIXES.some((p) => under(pathname, p)) ? PRP_ONLY_HOME : null;
}
